import {Component, EventEmitter, Input, Output} from "@angular/core";
import {LocalizationStrings} from "../../i18n/i18n-model";

@Component({
    selector: "action-button",
    templateUrl: "./action-button.component.html",
    standalone: false
})
export class ActionButtonComponent {
  @Input() buttonType: "submit" | "button" = "submit";

  @Input() buttonClass = "btn btn-primary";

  @Input() buttonLabel: keyof LocalizationStrings | undefined;

  @Input() iconClass: string | undefined;

  @Input() actionInProgressLabel: keyof LocalizationStrings | undefined;

  @Input() actionInProgress: boolean | null = false;

  @Input() spinnerClass = "spinner-border spinner-border-sm";

  @Input() buttonDisabled = false;

  @Input() testId: String | undefined;

  @Input() toolTip: keyof LocalizationStrings | undefined;

  @Output()
  private buttonClick: EventEmitter<void> = new EventEmitter<void>();

  onButtonClick() {
    this.buttonClick.emit();
  }
}
